<template>
    <div class="course-preview" ref="nsts">
        <transition name="nstsimg">
            <div v-if="isShow" id="nsts">
                <!-- 关闭按钮 -->
                <el-button @click="closeFullScreen()" id="btnclose" class="exit" type="danger" size="mini"
                           icon="el-icon-close" round :title="$t('c.logOut')"></el-button>
                <!-- 课件内容 -->
                <div class="course">
                    <header class="header">
                        <div class="logo">
                            <img src="../../assets/images/common/nav_logo.png" alt="LOGO">
                        </div>
                        <h3 class="title">{{title}}</h3>
                    </header>
                    <main class="main" :class="{active: isChapterHide}">
                        <section class="content">
                            <section class="course-img" v-show="sectionType==12">
                                <div class="course-img-tb">
                                    <div class="course-img-tbCell">
                                        <img :src="sectionImgSrc" alt="Course Image">
                                    </div>
                                </div>
                            </section>
                            <div class="course-doc" v-show="sectionType==8">
                                <iframe class="doc" :src="sectionDocSrc" frameborder="0"></iframe>
                            </div>
                            <!-- STEP: audio音频 -->
                            <div class="course-audio" v-show="sectionType === 11">
                                <div class="video-player vjs-custom-skin" v-if="hasAudioSection">
                                    <div
                                        id="vjs_video_4669"
                                        class="video-js vjs_video_4669-dimensions vjs-fluid vjs-controls-enabled vjs-workinghover vjs-v7 vjs-has-started"
                                        :class="isAudioPlaying ?'vjs-playing':'vjs-paused'"
                                        lang="zh-cn" role="region"
                                        aria-label="音频播放器"
                                    >
                                        <img
                                            id="vjs_video_4669_html5_api"
                                            class="vjs-tech"
                                            src="../../assets/images/course/audio_bg.png"
                                            @click="pauseAudioMusic"
                                        />

                                        <button class="vjs-big-play-button" type="button" title="播放音频" aria-disabled="false" @click="playAudioMusic">
                                            <span aria-hidden="true" class="vjs-icon-placeholder"></span>
                                            <span class="vjs-control-text" aria-live="polite">播放音频</span>
                                        </button>
                                        <div class="aplayer-control-bar">
                                            <aplayer
                                                :controls="true"
                                                style="margin:0"
                                                ref="audioPlayer"
                                                :music="audioMusic"
                                                repeat="repeat-one"
                                                @timeupdate="onAudioTimeUpdate"
                                                @seeking="onAudioSeeking"
                                                @ended="onAudioEnded"
                                                @play="playAudioMusic"
                                                @pause="pauseAudioMusic"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="course-video" v-show="sectionType==10">
                                <video-player class="video-player-c vjs-custom-skin"
                                    ref="videoPlayer"
                                    :playsinline="true"
                                    :options="playerOptions"
                                    @ready="playerReadied"
                                    @play="onPlayerPlay($event)"
                                    @pause="onPlayerPause($event)"
                                >
                                    <div class="" id="barrage"></div>
                                </video-player>
                            </div>
                        </section>
                        <section class="nav" :class="{active: isChapterHide}">
                            <el-button class="chapter-btn" type="primary" @click="isChapterHide = !isChapterHide"
                                       size="small">
                                <i class="nucfont inuc-bars"></i>
                                <br/>
                                {{$t('course.chapter')}}
                            </el-button>
                            <nav class="active">
                                <div class="chapter-list">
                                    <div class="chapter-item" v-for="(chapter, key) in chapters" :key="key">
                                        <h3>{{$t('course.theChapter', [chapter.order])}} {{chapter.name}}</h3>
                                        <ul>
                                            <li :class="{active: sectionID == section.id}"
                                                v-for="(section, key_s) in chapter.sections" :key="key_s"
                                                @click="displaySection(section.id, chapter.id)">
                                                <div class="info">
                                                    <i class="el-icon-caret-right"></i>
                                                    {{ chapter.order }}-{{ section.order }} {{ section.name }}
                                                </div>
                                                <div class="status">
                                                    <span>{{$t('course.viewing')}}<i class="el-icon-time"></i></span>
                                                    <!-- <i class="el-icon-success"></i> -->
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </section>
                    </main>
                </div>

                <!-- 课件评论 -->
                <course-comment
                    :courseData="courseData"
                    :courseID="courseData.id"
                    :chapterID="chapterID"
                    :sectionID="sectionID"
                ></course-comment>

                <el-dialog
                    :title="$t('m.tip')"
                    :visible.sync="dialogVisible"
                    width="30%">
                    <span>{{$t('course.sectionCannotDisplay')}}</span>
                    <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogVisible = false">{{$t('c.confirm')}}</el-button>
                </span>
                </el-dialog>
            </div>
        </transition>
    </div>
</template>

<script>
    import api from '@/api'
    import { screenfull } from '@/utils'
    import Aplayer from 'vue-aplayer'
    import CourseComment from "@/components/Comment/CourseComment"
    import VideoPlayer from "@/components/VideoPlayer"

    Aplayer.disableVersionBadge = true

    export default {
        name: 'coursePreview',
        components: {
            Aplayer,
            VideoPlayer,
            CourseComment
        },
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            courseID: {
                type: String
            }
        },
        data () {
            return {
                classname: ['style1', 'style2', 'style3'],
                dialogVisible: false,
                isChapterHide: false,
                title: 'Theory course',
                courseData: {},
                sectionType: 1,
                sectionImgSrc: '',
                sectionDocSrc: '',
                sectionID: '',
                chapterID: '',
                chapters: [],
                playerOptions: {
                    autoplay: false,
                    muted: false,
                    loop: false,
                    preload: 'auto',
                    language: 'zh-CN',
                    aspectRatio: '16:9',
                    fluid: true,
                    // sources: [{
                    //     type: 'application/x-mpegURL',
                    //     src: 'https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8',
                    //     withCredentials: false
                    // }],
                    sources: [],
                    'poster': "https://i5.hexun.com/2017-10-30/191428422.jpg",
                    width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频涉及违规信息，暂无法播放，请稍后再试',
                    html5: {hls: {withCredentials: false}},
                },
                hasVideoSection: true,

                // 多长时间(s)不操作界面，就暂停视频；false关闭该功能
                videoTimeout: false,
                // auido
                audioMusic: '',
                isAudioPlaying: false,
                hasAudioSection: false,
            }
        },
        computed: {
            player() {
                return this.$refs.videoPlayer.player
            }
        },
        watch: {
            isShow(v) {
                if (!this.videoTimeout) return;

                if (v) {
                    this.operationTimeoutListener();
                } else {
                    clearInterval(window.operatonTimeoutTimer);
                }
            }
        },
        mounted () {
            this.docNsts = this.$refs.nsts
            $('.course-preview').on('contextmenu', () => {return false})

            // 监听 esc 按键触发
            $(window).on('resize.course', e => {
                if (!screenfull.isFull() && !this.issafari()) {
                    this.closeFullScreen()
                }
            })

            if (this.issafari()) {
                $(document).on('webkitfullscreenchange', () => {
                    if (!screenfull.isFull()) {
                        this.closeFullScreen()
                    }
                })
            }

            this.$once('hook:beforeDestroy', () => {
                $(window).off('resize.course')
                $(document).off('webkitfullscreenchange')
            })
        },
        methods: {
            issafari(){
                var ua = navigator.userAgent.toLocaleLowerCase();

                return (/safari/.test(ua) && !/chrome/.test(ua))
            },
            fetchCourseData() {
                this.$nextTick(() => {
                    api.getTheoryCourseDetail(this.courseID).then(data => {
                        this.courseData = data.package
                        this.chapters = data.package.chapters;
                        this.title = data.package.name;
                        this.sections = this.chapters.map(item => item.sections).reduce((pre, cur) => pre.concat(cur));
                        let videoSection = this.sections.filter(item => item.type === 10)
                        let audioSection = this.sections.filter(item => item.type === 11)
                        if (videoSection.length === 0) {
                            this.hasVideoSection = false
                        }
                        if (audioSection.length > 0) {
                            this.hasAudioSection = true
                        }

                        let currentSection = this.sections[0];
                        this.displaySection(currentSection.id, this.chapters[0].id)
                    })
                })
            },
            displaySection(sectionid, chapterid) {
                this.sectionID = sectionid;
                this.chapterID = chapterid

                let currentSection = this.sections.filter(item => item.id === sectionid)[0];
                if (currentSection.resource.status !== 2) {
                    this.dialogVisible = true;
                    return
                }
                if (currentSection.type === 10) {
                    this.hasAudioSection && this.pauseAudioMusic()
                    this.$set(this.playerOptions.sources, 0, {
                        type: currentSection.resource.entity.url.endsWith('.mp4') ? 'video/mp4' : 'application/x-mpegURL',
                        src: currentSection.resource.entity.url,
                    });
                    if (currentSection.resource.entity.thumbnail) {
                        this.$set(this.playerOptions, 'poster', currentSection.resource.entity.thumbnail)
                    }

                    this.player.muted(false);
                    setTimeout(() => {
                        this.player.play()
                    }, 300);
                    this.sectionType = currentSection.type
                } else if (currentSection.type === 12) {
                    this.player.pause();
                    this.hasAudioSection && this.pauseAudioMusic()
                    this.sectionType = currentSection.type;
                    this.sectionImgSrc = currentSection.resource.entity.url
                } else if (currentSection.type === 8) {
                    this.player.pause();
                    this.hasAudioSection && this.pauseAudioMusic()
                    this.sectionType = currentSection.type;
                    this.sectionDocSrc = encodeURI(currentSection.resource.entity.url)
                } else if (currentSection.type === 11) {
                    this.hasVideoSection && this.player.pause()
                    this.sectionType = currentSection.type

                    this.audioMusic = {
                        title: currentSection.resource.name,
                        artist: currentSection.resource.creatorName,
                        src: currentSection.resource.entity.url,
                        pic: require('../../assets/images/course/play_bg.jpg')
                    }
                    this.playAudioMusic()
                }
            },
            playAudioMusic() {
                this.$nextTick(() => {
                    this.isAudioPlaying = true
                    this.$refs.audioPlayer.play()
                })
            },
            pauseAudioMusic() {
                this.$nextTick(() => {
                    this.isAudioPlaying = false
                    this.$refs.audioPlayer.pause()
                })
            },
            onAudioEnded(e) {
                console.log('end',this.$refs.audioPlayer)
                setTimeout(() => {
                    this.pauseAudioMusic()
                }, 0)
            },
            playerReadied () {
            },
            onPlayerPlay(player) {
                // console.log("play");
            },
            onPlayerPause(player){
                // console.log("pause");
            },

            // 长时间无操作时，暂停视频
            operationTimeoutListener() {
                if (!this.isShow) return;

                const intervalTime = this.videoTimeout;
                let time = intervalTime;

                // reset
                $('body').on('keydown mousemove mousedown', function(e) {
                    time = intervalTime;
                });

                clearInterval(window.operatonTimeoutTimer);
                window.operatonTimeoutTimer = setInterval(() => {
                    time--;
                    if (time <= 0) {
                        this.player.pause();
                        time = intervalTime;
                    }
                }, 1000);
            },

            closeFullScreen () {
                this.$emit('courseExit', false);
                screenfull.exit();
                this.sectionID = ''
            },
            fullScreen () {
                screenfull.request(this.docNsts);
                this.fetchCourseData()
            },
        },
    }
</script>

<style lang="scss" scoped>
    .course-preview {
        .course {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            max-width: 100%;
        }
        .header {
            flex-shrink: 0;
            height: 72px;
            line-height: 72px;
            background: #262626;
            color: #fff;
            text-align: center;
            .title {
                font-size: 24px;
            }
            .logo {
                position: absolute;
                margin-left: 10px;
            }
        }
        .main {
            position: relative;
            flex: 1;
            display: flex;
            background: #444;
            padding-right: 384px;
            transition: all .5s;
            overflow: hidden;
            &.active {
                padding-right: 0;
            }
            .content {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                > div {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .course-img {
                    overflow-y: auto;
                    width: 100%;
                    height: 100%;

                    &-tb {
                        display: table;
                        width: 100%;
                        height: 100%;
                    }

                    &-tbCell {
                        display: table-cell;
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                        height: 100%;
                    }

                    img {
                        max-width: 100%;
                    }
                }
                .course-audio {
                    .video-player, .video-js {
                        width: 100%;
                        height: 100%;
                        .vjs-tech {
                            object-fit: contain;
                        }
                    }
                }
                .course-doc {
                    .doc {
                        width: 100%;
                        height: 100%;
                    }
                    iframe {
                        background-color: #fefefe;
                    }
                }
                .course-video {
                    display: flex;
                    align-items: center;
                    max-height: 100%;
                    .video-player-c {
                        width: 100%;
                        height: 100%;
                        > div {
                            height: 100%;
                        }
                    }
                }
            }
            .nav {
                position: absolute;
                right: 0;
                width: 384px;
                height: 100%;
                transition: all .5s;
                &.active {
                    transform: translateX(384px);
                }
                .chapter-btn {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -70px;
                    width: 70px;
                    padding-left: 0;
                    padding-right: 0;
                    z-index: 99;
                    i {
                        display: inline-block;
                        margin-bottom: 5px;
                    }
                }
                nav {
                    height: 100%;
                    padding: 10px 15px 0;
                    background: #333;
                    overflow-y: auto;
                }
            }
            .chapter-item {
                color: #fff;
                h3 {
                    padding: 5px 0;
                    font-size: 16px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                ul {
                    padding-left: 15px;
                    li {
                        display: flex;
                        padding: 10px;
                        border-radius: 4px;
                        transition: color .15s;
                        cursor: pointer;

                        &:hover {
                            color: #00b33b;
                            background-color: lighten(#333, 3%);
                        }
                        &.active {
                            color: #00b33b;

                            .status span {
                                display: inline-block;
                            }
                        }
                        .info {
                            width: 100%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .status {
                            flex-shrink: 0;
                            float: right;
                            span {
                                display: none;
                                font-size: 12px;
                                i {
                                    margin-left: 5px;
                                }
                            }
                            .el-icon-success {
                                color: #00b33b;
                            }
                        }
                    }
                }
            }
        }
    }
</style>

<style lang="scss">
    @import "~@/style/const";

    .course-preview {
        @include scrollbar(#666);
        #nsts {
            overflow: auto;
        }
        .video-player-c > div {
            height: 100%;
            padding: 0;
        }
        .aplayer-control-bar {
            position: absolute;
            width: 100%;
            bottom: 0;
            right: 0;
            left: 0;

            .aplayer {
                .aplayer-controller .aplayer-time .aplayer-icon.inactive {
                    display: none;
                }
                .aplayer-bar {
                    overflow: hidden;
                }
            }

        }
    }

</style>
